<template>
    <form @submit="onSubmit">
        <div class="font-body flex flex-col justify-center space-y-5">
            <p class="text-muval-gray-2 text-sm">
                Search for the order this message belongs to. Moving it removes it from the current order's timeline.
            </p>

            <p
                v-if="suggestedOrders.length > 1"
                class="text-muval-gray-2 text-sm"
            >
                The sender matches {{ suggestedOrders.length }} orders on their customer record. Pick the right one.
            </p>

            <OrderRefDropdown
                vid="order_id"
                class="w-full"
                placeholder="Search orders by ref or customer"
                :suggestedOrders="suggestedOrders"
                :defaultOpen="suggestedOrders.length > 1"
            />

            <ErrorDetails :errorData="errorObject" />

            <div class="flex">
                <div class="ml-auto flex gap-5">
                    <MuvalButton
                        quaternary
                        type="button"
                        @click.prevent="$emit('cancel:modal')"
                    >
                        Cancel
                    </MuvalButton>
                    <MuvalButton :loading="loading">Move to order</MuvalButton>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import OrderRefDropdown from '@inputs/OrderRefDropdown.vue';
import MuvalButton from '@buttons/MuvalButton.vue';
import ErrorDetails from '@components/errors/ErrorDetails.vue';
import { useForm } from 'vee-validate';
import { toast } from 'vue-sonner';

const props = defineProps({
    itemId: {
        type: Number,
        required: true,
    },
    // `suggestedOrders` from the inbox row: the sender's PIPE/JOB/JOB_PARTIAL orders (CU-86d3vgzcg).
    data: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const suggestedOrders = computed(() => props.data?.suggestedOrders ?? []);

const emit = defineEmits(['close:modal', 'cancel:modal']);

const errorObject = ref({
    message: null,
    errors: null,
});

// A lone suggestion is preselected; several are listed with none chosen, so the
// agent always picks one. Nothing is saved until the form is submitted.
const form = reactive(
    useForm({
        initialValues: {
            order_id: suggestedOrders.value.length === 1 ? suggestedOrders.value[0].id : null,
        },
    }),
);
const loading = ref(false);

const onSubmit = form.handleSubmit(async (values) => {
    try {
        loading.value = true;
        await window.tenantAxios.patch(`/inbox/${props.itemId}/order`, {
            order_id: values.order_id,
        });
        toast.success('Message moved to the selected order.');
        emit('close:modal');
    } catch (error) {
        errorObject.value.message = error.message;
        errorObject.value.errors = error.errors;
        form.setErrors(error.errors ?? {});
    } finally {
        loading.value = false;
    }
});
</script>
